import Utils from "./Utils";
import * as THREE from "three";
import GlobalColorSingleton from "./GlobalColor";
export default class TitleTexture {
  constructor(url) {
    this.url = url;
  }

  async load() {
    return new Promise(async (resolve, reject) => {
      const data = await Utils.loadJSON(this.url);
      console.log(data);
      const url = data.letters[Math.floor(Math.random() * data.letters.length)];
      // console.log(url);
      await GlobalColorSingleton.getColorFromImage(`getImage/${url}`);

      const promise_array = [];
      const loader = new THREE.TextureLoader();
      let w = 0;
      for (const image_url of data.letters) {
        promise_array.push(loader.load(`getImage/${image_url}`));
        // if (w > 15) break;
        // promise_array.push(
        //   loader.load(`images/smaller_island/1ajia11AtsDkaZGN_p_${w}.png.jpg`)
        // );
        // w++;
      }
      const dictionary = await Promise.all(promise_array).then((values) => {
        console.log("*************", values);
        const dict = {};
        let w = 0;
        for (const image_url of data.letters) {
          const tmp = image_url.split("_");
          // console.log(
          //   "image_url",
          //   image_url,
          //   image_url.split("_"),
          //   tmp[tmp.length - 2]
          // );
          // const letter = image_url.split("_").at(-2).toLowerCase();
          const letter = tmp[tmp.length - 2].toLowerCase();
          if (!dict[letter]) {
            dict[letter] = [];
          }
          dict[letter].push(values[w]);
          w++;
        }
        dict["default"] = [this.createDefaultTexture()];
        return dict;
      });

      resolve(dictionary);
    });
  }

  createDefaultTexture() {
    // create a texture with default DEFAULT_COLOR
    let canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    let context = canvas.getContext("2d");
    context.fillStyle = "#" + GlobalColorSingleton.tmp_color.toString(16);
    context.fillRect(0, 0, 1, 1);
    let defaultTexture = new THREE.CanvasTexture(canvas);
    defaultTexture._colorValue =
      "#" + GlobalColorSingleton.tmp_color.toString(16);
    return defaultTexture;
  }
}
